export const QUIZ_BUZZER_PHASES = ["LOBBY", "QUESTION", "ROUND_RESULT", "PAUSED", "FINISHED"];
const transitions = {
    START: ["LOBBY"],
    ANSWER: ["QUESTION"],
    ROUND_COMPLETE: ["QUESTION"],
    NEXT_ROUND: ["ROUND_RESULT"],
    FINISH: ["ROUND_RESULT"],
    PAUSE: ["QUESTION", "ROUND_RESULT"],
    RESUME: ["PAUSED"],
    SKIP_ROUND: ["QUESTION"],
    END: ["LOBBY", "QUESTION", "ROUND_RESULT", "PAUSED"],
    PLAY_AGAIN: ["FINISHED"]
};
export function canTransitionQuizBuzzer(phase, event) {
    return transitions[event].includes(phase);
}
export function transitionQuizBuzzer(phase, event, options = {}) {
    if (!canTransitionQuizBuzzer(phase, event))
        throw new Error(`INVALID_TRANSITION:${phase}:${event}`);
    switch (event) {
        case "START":
        case "NEXT_ROUND": return "QUESTION";
        case "ANSWER": return "QUESTION";
        case "ROUND_COMPLETE":
        case "SKIP_ROUND": return "ROUND_RESULT";
        case "PAUSE": return "PAUSED";
        case "RESUME":
            if (!options.resumePhase)
                throw new Error("RESUME_PHASE_REQUIRED");
            return options.resumePhase;
        case "FINISH":
        case "END": return "FINISHED";
        case "PLAY_AGAIN": return "LOBBY";
    }
}
export function scoreQuizAnswer(correct, responseMs, answerWindowMs, scoring) {
    if (!correct)
        return 0;
    const duration = Math.max(1, answerWindowMs);
    const elapsed = Math.min(duration, Math.max(0, responseMs));
    const speedBonus = Math.round(scoring.speedBonusMaxPoints * (1 - elapsed / duration));
    return scoring.correctBasePoints + Math.max(0, speedBonus);
}
//# sourceMappingURL=quiz-buzzer-machine.js.map